import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';
import PropTypes from 'prop-types';
import { Button } from '@uhg-abyss/web/ui/Button';
import { useSelector } from 'react-redux';

const ModalText = styled('p', {
  fontSize: '15px',
});

const Note = styled('p', {
  fontWeight: 'bold',
  // marginTop: '15px',
});

const ButtonStyle = styled('div', {
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: '20px',
});

export const SecretExpireModalV2 = ({ showModal, modalOnClose }) => {
  const credentials = useSelector((state) => {
    return state.GET_CREDENTIALS_V2.data;
  });

  const stageAlert =
    credentials?.stage?.secrets?.filter((secret) => {
      return secret.expiresInDays !== null && secret.expiresInDays <= 30;
    }).length > 0;

  const prodAlert =
    credentials?.prod?.secrets?.filter((secret) => {
      return secret.expiresInDays !== null && secret.expiresInDays <= 30;
    }).length > 0;

  const credentialsAPIEnvironment = () => {
    let env = '';
    if (prodAlert && stageAlert) {
      env = 'prod and stage';
    } else if (prodAlert) {
      env = 'prod';
    } else if (stageAlert) {
      env = 'stage';
    }

    return env;
  };

  const title = `One or more of your organization's credentials will expire soon.`;

  return (
    <ModalDialog
      size="$md"
      header={title}
      isOpen={showModal}
      closeOnClickOutside={false}
      onClose={() => {
        return modalOnClose(false);
      }}
      css={{
        'abyss-modal-base-header': {
          color: 'rgb(0, 38, 119)',
          fontFamily: 'AbyssUHCSerif, Georgia Bold, serif !important',
          fontSize: '32px !important',
          padding: '16px 0px 0px',
        },
        'abyss-modal-base-body': {
          color: '#000',
          marginBottom: '0px',
        },
      }}
    >
      <ModalText>
        To keep your API credentials active in {credentialsAPIEnvironment()},
        you must generate a new client secret using the following steps:
        Dashboard {'>'} My Organization {'>'} Credentials. You can confirm the
        expiration date for each secret by reviewing the <b>Expires on: </b>
        date listed below the secret.
      </ModalText>
      <Note>Note: Only the secret keeper is able to update the secret.</Note>
      <ButtonStyle>
        <Button
          onClick={() => {
            return modalOnClose(false);
          }}
        >
          Acknowledged
        </Button>
      </ButtonStyle>
    </ModalDialog>
  );
};

SecretExpireModalV2.propTypes = {
  showModal: PropTypes.bool.isRequired,
  modalOnClose: PropTypes.func.isRequired,
};
